/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable arrow-body-style */
import { apiClient, handleResponse } from './axios';

async function getAll(companyId) {
  try {
    const response = await apiClient
      .get(`/group/company/${companyId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getAllGroups() {
  try {
    const response = await apiClient
      .get('/group');
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getAllGroupsWithExamByCompany(id) {
  try {
    const response = await apiClient
      .get(`/group/exam/company/${id}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getAllGroupsWithExamByDate(body) {
  try {
    const response = await apiClient
      .post('/group/examByDate', body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getAllGroupsWithExam() {
  try {
    const response = await apiClient
      .get('/group/exam');
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getAllFormated(companyId) {
  try {
    const response = await apiClient
      .get(`/group/company/${companyId}`);
    const res = await handleResponse(response);
    const group = [];
    Object.keys(res).forEach((key) => {
      group.push({ value: res[key]._id, label: `${res[key].name}`, user: res[key].listIdUsers });
    });
    return (group);
  } catch (error) {
    return error.response;
  }
}

async function getAllGroupsId() {
  try {
    const response = await apiClient
      .get('/groupsid');
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getGroupByCompanyList(companyId) {
  try {
    const groups = await apiClient
      .get(`/group/company/${companyId}`);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getDataTableWithChart(id) {
  try {
    const response = await apiClient.get(`/export/json/group/${id}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getGroupByCompagnyList(companyId) {
  try {
    const response = await apiClient
      .get(`/group/company/${companyId}`);
    const res = await handleResponse(response);
    const tempArrayGroupsOptions = [];
    for (const key in res) {
      tempArrayGroupsOptions.push({
        value: res[key]._id,
        label: res[key].name,
        id: res[key]._id,
      });
    }
    const groups = tempArrayGroupsOptions;
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function addUserToGroup(userId, body) {
  try {
    const response = await apiClient
      .put(`/group/user/${userId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function deleteUserGroup(groupId, userId) {
  try {
    const response = await apiClient
      .delete(`/group/${groupId}/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getGroupByUser(userId) {
  try {
    const response = await apiClient
      .get(`/group/user/${userId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

const formatTeacher = (teachers) => {
  try {
    const formatedTeachers = [];
    if (teachers !== undefined) {
      for (let i = 0; i < teachers.length; i += 1) {
        formatedTeachers.push({
          label: `${teachers[i].name} ${teachers[i].firstname}`,
          value: teachers[i].name,
          id: teachers[i]._id,
        });
      }
    }
    return formatedTeachers;
  } catch (error) {
    return error.response;
  }
};

const formatCourses = (courses) => {
  try {
    const formatedCourses = [];
    if (courses !== undefined) {
      for (let i = 0; i < courses.length; i += 1) {
        formatedCourses.push({
          label: courses[i].name,
          value: courses[i].name,
          id: courses[i]._id,
        });
      }
    }
    return formatedCourses;
  } catch (error) {
    return error.response;
  }
};

async function getGroupById(groupId) {
  try {
    const reponse = await apiClient
      .get(`/group/${groupId}`);
    reponse.data.idTeachers = formatTeacher(reponse.data.idTeachers);
    reponse.data.courses = formatCourses(reponse.data.courses);
    return reponse.data;
  } catch (error) {
    return error.response;
  }
}

async function getGroupWithExam(groupId) {
  try {
    const reponse = await apiClient
      .get(`/group/exam/${groupId}`);
    reponse.data.idTeachers = formatTeacher(reponse.data.idTeachers);
    reponse.data.courses = formatCourses(reponse.data.courses);
    return reponse.data;
  } catch (error) {
    return error.response;
  }
}

async function getGroupWithExamResults(groupId) {
  try {
    const reponse = await apiClient
      .get(`/group/exam/result/${groupId}`);
    return reponse.data;
  } catch (error) {
    return error.response;
  }
}

async function getGroupsByCompany(companyId) {
  try {
    const response = await apiClient
      .get(`/groups/${companyId}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function getGroupByCoursePlan(coursePlanId) {
  try {
    const response = await apiClient
      .get(`/group/courseplan/${coursePlanId}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function addGroupToCompany(body) {
  try {
    const response = await apiClient
      .post('/group/', body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function updateCompany(companyId, body) {
  try {
    const response = await apiClient
      .put(`/company/group/${companyId}`, body);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

async function getGroupsDataByCompagny(companyId) {
  try {
    const res = await apiClient
      .get(`/group/company/${companyId}`);
    const groups = res;
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function updateGroup(groupId, body) {
  try {
    const response = await apiClient
      .put(`/group/${groupId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function deleteGroup(groupId, body) {
  try {
    const response = await apiClient
      .delete(`/group/${groupId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function addObjective(groupId, body) {
  try {
    const response = await apiClient
      .post(`/objectives/group/${groupId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getPDF(groupId) {
  try {
    const response = await apiClient
      .get(`/export/pdf/group/${groupId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function getDataTableWithChartBySemester(groupId, groupId2, companyId, semester) {
  try {
    const response = await apiClient
      .get(`/export/json/semester/${groupId}/${groupId2}/${companyId}/${semester}`);
    const data = await handleResponse(response);
    return (data);
  } catch (error) {
    return error.response;
  }
}

async function deleteExam(elearningOptionsId) {
  try {
    const response = await apiClient
      .put(`/exam/delete/${elearningOptionsId}`);
    const elearning = await handleResponse(response);
    return elearning;
  } catch (error) {
    return error.response;
  }
}

async function getCoursePlan(groupId) {
  try {
    const response = await apiClient
      .get(`/export/pdf/group/${groupId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function archiveGroup(groupId, adminId) {
  try {
    const response = await apiClient
      .delete(`/group/archive/${groupId}/${adminId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

const groupServices = {
  archiveGroup,
  getAll,
  getDataTableWithChartBySemester,
  getGroupByCompagnyList,
  deleteUserGroup,
  addUserToGroup,
  getGroupById,
  getGroupByUser,
  addGroupToCompany,
  getGroupsByCompany,
  getGroupsDataByCompagny,
  updateCompany,
  updateGroup,
  deleteGroup,
  getGroupByCompanyList,
  getAllGroups,
  addObjective,
  getPDF,
  getAllGroupsId,
  getAllGroupsWithExamByDate,
  getAllGroupsWithExamByCompany,
  getDataTableWithChart,
  getAllFormated,
  getGroupWithExamResults,
  getAllGroupsWithExam,
  getGroupWithExam,
  deleteExam,
  getCoursePlan,
  getGroupByCoursePlan,
};

export default groupServices;
